<template>
    <div v-if="isAvailable">
        <b-btn @click="prePublish" class="btn-card-action btn-card-action-green my-1">Опубликовать</b-btn>

        <b-modal ref="publish-modal" v-model="isModalVisible" centered hide-header-close no-close-on-backdrop no-close-on-esc size="lg" :title="title" @hidden="clearEmails">
            <b-form-group :state="!!emails.length" class="w-100">
                <div class="d-block text-left mb-3">Выберите или введите почтовые ящики поставщиков, на них будут отправлены приглашения к закупке.</div>
                <multiselect
                    id="org-select"
                    v-model="emails"
                    :class="{ 'is-valid': emails.length, 'is-invalid': !emails.length }"
                    :close-on-select="true"
                    :clear-on-select="true"
                    :internal-search="false"
                    :loading="isLoading"
                    :multiple="true"
                    :options="organizations"
                    :options-limit="100"
                    :preserve-search="false"
                    :taggable="true"
                    deselect-label="Отменить"
                    label="name"
                    placeholder="Выберите организации / укажите адреса электронной почты"
                    select-label="Выбрать"
                    selected-label="Выбрано"
                    tag-placeholder="Добавить"
                    track-by="id"
                    @tag="addTag"
                    @search-change="asyncFind">
                    <span slot="noOptions">Нет данных.</span>
                    <span slot="noResult">Записей, соответствующих вашему запросу, не найдено.</span>
                </multiselect>
                <template v-if="!emails.length">
                    <b-form-invalid-feedback force-show>Поле обязательно для заполнения</b-form-invalid-feedback>
                </template>
            </b-form-group>
            <div slot="modal-footer" class="w-100 text-">
                <b-overlay :show="isDataSending" class="d-inline-block" opacity="0.6" rounded spinner-small spinner-variant="primary">
                    <b-button class="text-uppercase mr-2" variant="custom-outline-secondary" @click="cancelModal">Отмена</b-button>
                </b-overlay>
                <b-overlay :show="isDataSending" class="d-inline-block" opacity="0.6" rounded spinner-small spinner-variant="primary">
                    <b-button :disabled="!emails.length" class="text-uppercase" variant="custom-green" @click="publishPurchase">Опубликовать</b-button>
                </b-overlay>
            </div>
        </b-modal>
    </div>
</template>

<script>
import debounceMixin from '@/mixins/debounce';

export default {
    name: 'cabinet-fl44-notice-card-publish-button',
    props: {
        purchase: {
            type: Object
        }
    },
    mixins: [debounceMixin],
    data() {
        return {
            isModalVisible: false,
            isDataSending: false,
            isLoading: false,
            organizations: [],
            emails: [],
            tags: []
        };
    },
    methods: {
        showModal() {
            this.isModalVisible = true;
        },
        cancelModal() {
            this.clearEmails();
            this.isModalVisible = false;
        },
        async asyncFind(query) {
            this.debounce(async () => {
                this.isLoading = true;
                query ? (this.organizations = await this.$api.organizations.search({ query })) : (this.organizations = []);
                this.organizations.push(...this.tags);
                this.isLoading = false;
            });
        },
        addTag(newTag) {
            const tag = {
                email: newTag,
                id: newTag,
                name: newTag
            };
            let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (re.test(tag.email)) {
                this.emails.push(tag);
                this.organizations.push(tag);
                this.tags.push(tag);
            }
        },
        clearEmails() {
            this.emails = [];
            this.tags = [];
        },
        prePublish() {
            if (this.purchase.flags.was_canceled) {
                this.publishPurchase();
            } else {
                this.isModalVisible = true;
            }
        },
        async publishPurchase() {
            this.isDataSending = true;
            if (await this.$api.personal[this.purchase.type === 'fl44' ? 'fl44' : 'fl44UnknownVolume'].publishPurchase(this.purchase.id, this.emails)) {
                this.cancelModal();
                this.$emit('action');
            }
            this.$emit('action');
            this.isDataSending = false;
        }
    },
    computed: {
        title() {
            return `Опубликовать закупку № ${this.purchase.purchase_info.reg_number}?`;
        },
        isAvailable() {
            return this.purchase.actions.publish;
        }
    }
};
</script>
